<template>
    <picture v-if="src.lg || src.md || src.sm">
        <source media="(max-width: 640px)" :srcset="src.sm" />
        <source media="(max-width: 1270px)" :srcset="src.md" />
        <img
            :src="src.lg"
            :alt="alt"
            class="h-full w-full object-cover"
            :width="width"
            :height="height"
        />
    </picture>
</template>

<script setup>
const { src, alt, classNames } = defineProps({
    src: {
        type: {
            sm: String,
            md: String,
            lg: String,
        },
        required: true,
    },
    alt: {
        type: String,
        required: true,
    },
    width: {
        type: Number,
        required: false,
    },
    height: {
        type: Number,
        required: false,
    },
});
</script>
